import { FONT_MONO } from '../theme';
import { Card } from '../ui';
import { CardTitle, EmptyNote } from './common';
import { fmtInt, signed } from './nutritionData';
import { shortDate } from './statsData';

const COLS = '58px minmax(0, 0.9fr) minmax(0, 1.3fr) 54px';

function Cell({ t, main, sub, align = 'left', color }) {
  return (
    <div role="cell" style={{ minWidth: 0, textAlign: align }}>
      <div style={{ fontSize: 13, fontFamily: FONT_MONO, fontWeight: 600, color: color || t.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{main}</div>
      {sub && <div style={{ fontSize: 10, color: t.textFaint, marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{sub}</div>}
    </div>
  );
}

/* The last 8 calendar weeks from logic/energy weeklyAdherence, newest first:
 * averages over complete days only, days on the kcal target (+-10%) and
 * days the protein target was hit (>= 90%), with the week's mean weight. */
export function NutritionWeeksCard({ t, weeks }) {
  const any = weeks.some(w => w.avg || w.avgWeight !== null);
  const head = { fontSize: 10, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: t.textFaint };

  return (
    <Card t={t} padding={16}>
      <CardTitle t={t} sub="Mon–Sun weeks, averages over complete days. On target = within 10%; P hit = 90%+ of protein.">
        Weekly averages
      </CardTitle>
      {!any ? (
        <EmptyNote t={t}>Log a few complete days to see weekly averages.</EmptyNote>
      ) : (
        <div role="table" aria-label="Weekly nutrition averages">
          <div role="row" style={{ display: 'grid', gridTemplateColumns: COLS, gap: 8, paddingBottom: 6 }}>
            <span role="columnheader" style={head}>Week of</span>
            <span role="columnheader" style={head}>kcal</span>
            <span role="columnheader" style={head}>P · C · F g</span>
            <span role="columnheader" style={{ ...head, textAlign: 'right' }}>kg</span>
          </div>
          {weeks.map(w => (
            <div key={w.weekStart} role="row" style={{
              display: 'grid', gridTemplateColumns: COLS, gap: 8, alignItems: 'center',
              padding: '7px 0', borderTop: `1px solid ${t.divider}`,
            }}>
              <Cell t={t} main={shortDate(w.weekStart)} sub={`${w.loggedDays}/${w.days} d${w.days < 7 ? ' so far' : ''}`} />
              <Cell t={t} main={w.avg ? fmtInt(w.avg.kcal) : '—'}
                sub={w.avg && w.kcalOnTargetDays !== null ? `${w.kcalOnTargetDays} on target` : null} />
              <Cell t={t} main={w.avg ? `${fmtInt(w.avg.protein)} · ${fmtInt(w.avg.carbs)} · ${fmtInt(w.avg.fats)}` : '—'}
                sub={w.avg && w.proteinHitDays !== null
                  ? `P hit ${w.proteinHitDays}${w.proteinPerKg !== null ? ` · ${w.proteinPerKg.toFixed(1)} g/kg` : ''}`
                  : null} />
              <Cell t={t} align="right" main={w.avgWeight !== null ? w.avgWeight.toFixed(1) : '—'}
                sub={w.weightChange !== null ? signed(w.weightChange, 1) : null} />
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
